<script setup>
import { getCurrentInstance } from 'vue';
import Button from "../../common/Button.vue";

const props = defineProps({
    item: {
        type: Object,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Methods ---

const openEditModal = () => {
    store.dispatch('modals/show', {
        componentName: 'ThemesEditorAddModal',
        obj: {
            id: props.item.id,
        }
    });
};
</script>

<template>
    <Button
        class="visible-on-hover-hidden px-1 btn-sm p-0"
        @click.stop.prevent.native="openEditModal"
    >
        <i class="bi-pencil-square"/>
    </Button>
</template>

<style scoped>
/* Scoped styles preserved for light, dark, and primary button contexts */
a {
    color: rgba(0,0,0,.6);
}

a:hover {
    color: #000;
}

[data-bs-theme="dark"] a,
.btn-primary a {
    color: rgba(255,255,255,.8);
}

[data-bs-theme="dark"] a:hover,
.btn-primary a:hover {
    color: #fff;
}
</style>